import React from "react";
import loadingLogo from '../../../img/Peiix_isotipo_color.png';
import '../../../Styles/SpinnerOverlay.css';

export const LoadingOverlay = () => {
  return (
    <div className="spinner-overlay">
      <div className="loading-logo-container">
        <div className="loading-logo grayscale" style={{ backgroundImage: `url(${loadingLogo})` }}></div>
        <div className="loading-logo color" style={{ backgroundImage: `url(${loadingLogo})` }}></div>
      </div>
      <div style={{ marginTop: '20px', color: '#3E4144', fontSize: '16px', fontWeight: 'bold' }}>Cargando transacciones...</div>
    </div>
  );
};